// Supported UI languages. `locale` drives date and number formatting.
// A language without its own dictionary falls back to Czech texts.
export const LANGUAGES = [
  { code: 'cs', label: 'Čeština', flag: '🇨🇿', locale: 'cs-CZ' },
  { code: 'en', label: 'English', flag: '🇬🇧', locale: 'en-GB' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱', locale: 'pl-PL' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪', locale: 'de-DE' },
];

export const DEFAULT_LANGUAGE = 'cs';
